export const isValidEthTransaction = (v: string) =>
  /^0x([A-Fa-f0-9]{64})$/gis.test(v.trim());
export const isValidEthAddress = (v: string) => /^0x[a-fA-F0-9]{40}$/gis.test(v.trim());
